"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslationsWithNamespaces = void 0;
var _defaultTranslations = require("./defaultTranslations");
/**
 * Combined translations with namespaces that language-switcher uses. Includes language-switcher namespaces
 */
const defaultTranslationsWithNamespaces = exports.defaultTranslationsWithNamespaces = {
  [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations
};
